import { STOCK_PLACE_MAP } from 'constant/stock-place';

const STOCK_PLACE_TIMEZONE_MAP: Record<string, string> = {
  [STOCK_PLACE_MAP.JAPAN]: 'Asia/Tokyo',
  [STOCK_PLACE_MAP.UMEDA]: 'Asia/Tokyo',
  [STOCK_PLACE_MAP.HONGKONG]: 'Asia/Hong_Kong',
  [STOCK_PLACE_MAP.SINGAPORE_ASU]: 'Asia/Singapore',
  [STOCK_PLACE_MAP.SINGAPORE_GX]: 'Asia/Singapore',
  [STOCK_PLACE_MAP.SINGAPORE_ASU_GST]: 'Asia/Singapore',
  [STOCK_PLACE_MAP.SHANG_HAI]: 'Asia/Shanghai',
  [STOCK_PLACE_MAP.DUBAI]: 'Asia/Dubai',
  [STOCK_PLACE_MAP.FRANCE]: 'Europe/Paris',
  [STOCK_PLACE_MAP.NEW_YORK]: 'America/New_York',
};

const TIMEZONE_ABBR_MAP: Record<string, string> = {
  'Asia/Tokyo': 'JST',
  'Asia/Hong_Kong': 'HKT',
  'Asia/Singapore': 'SGT',
  'Asia/Shanghai': 'CST',
  'Asia/Dubai': 'GST',
  'Europe/Paris': 'CET',
  'America/New_York': 'ET',
};

export const getTimezoneAbbr = (timezone?: string): string | undefined => {
  if (!timezone) return undefined;
  return TIMEZONE_ABBR_MAP[timezone];
};

export const getTimezoneByStockPlace = (
  stockPlace?: string,
): string | undefined => {
  if (!stockPlace) return undefined;

  const timezone = STOCK_PLACE_TIMEZONE_MAP[stockPlace];

  if (!timezone && process.env.NODE_ENV === 'development') {
    console.warn(`Unknown stockPlace for timezone mapping: ${stockPlace}`);
  }

  return timezone;
};

export default getTimezoneByStockPlace;
